/*
 * EB Pack Core — utilidades compartidas para configurador libre y guiado.
 * - addPackToCart(items, options) — batch add con _pack_grupo property.
 * - generateGroupId() — id corto único por sesión.
 * - formatMoney(cents)
 */
(function () {
  if (window.EBPack) return;

  function generateGroupId() {
    const date = Date.now().toString(36);
    const rand = Math.random().toString(36).slice(2, 8);
    return `pk_${date}${rand}`;
  }

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: currency || 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format((cents || 0) / 100);
  }

  /**
   * @param {Array<{variantId: string|number, quantity?: number, properties?: object}>} items
   * @param {{groupId?: string, sourceLabel?: string, openDrawer?: boolean}} [options]
   */
  async function addPackToCart(items, options) {
    if (!items || items.length === 0) {
      throw new Error('Pack vacío');
    }
    const opts = options || {};
    const groupId = opts.groupId || generateGroupId();

    const payload = {
      items: items.map((it) => ({
        id: parseInt(it.variantId, 10),
        quantity: it.quantity || 1,
        properties: Object.assign(
          { _pack_grupo: groupId },
          opts.sourceLabel ? { _pack_source: opts.sourceLabel } : {},
          it.properties || {}
        ),
      })),
    };

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'cart add failed');
    }
    const data = await res.json();

    if (window.EBCart) await window.EBCart.refresh('eb-pack-core');

    document.dispatchEvent(new CustomEvent('cart:add', {
      detail: { source: 'eb-pack-core', resource: data, data: { source: 'eb-pack-core' } }
    }));
    document.dispatchEvent(new CustomEvent('cart:update', {
      detail: { source: 'eb-pack-core', resource: window.EBCart?.state || data, data: { source: 'eb-pack-core' } }
    }));

    if (opts.openDrawer !== false) {
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        try { drawer.open(); } catch (_e) { /* swallow */ }
      }
      // Si la página no incluye el cart drawer (ej. /pages/configura-tu-pack),
      // el caller decide si navegar a /cart manualmente.
    }

    return { groupId, response: data };
  }

  window.EBPack = { addPackToCart, generateGroupId, formatMoney };
})();
